module.exports = __webpack_public_path__ + "img/1.285e742e.png";